module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/design/pixels-046bf3413b069155589023e1e1650dbe.svg";